import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={38}
    height={38}
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28.6926 21.7078C29.0179 22.4587 29.2072 23.3776 29.249 24.44C30.3468 24.6916 31.1683 25.6735 31.1683 26.8462C31.1683 28.2081 30.0603 29.3162 28.6983 29.3162C27.3364 29.3162 26.2283 28.2081 26.2283 26.8462C26.2283 25.6868 27.032 24.7152 28.1105 24.4495C28.063 23.3943 27.8107 21.7888 26.7778 20.9961C26.2508 20.8597 25.7089 20.7609 25.1529 20.71C25.1119 22.5587 19.0015 27.1209 19.0015 27.1209C19.0015 27.1209 12.8892 22.5594 12.8478 20.7107C12.2303 20.767 11.6295 20.8798 11.0492 21.0425C10.2957 21.6391 9.90582 22.7506 9.88568 24.3663C10.1072 24.4936 10.2862 24.6924 10.396 24.9329C11.2077 25.3163 11.9248 26.1227 12.4739 27.2707C12.5658 27.4637 12.578 27.6818 12.5103 27.8809C12.8394 28.728 13.0275 29.6536 13.0275 30.4311C13.0275 31.5206 13.0275 32.5508 11.84 32.8152C11.7116 32.922 11.5505 32.9809 11.3814 32.9809H10.5879C10.1901 32.9809 9.8663 32.6564 9.8663 32.2597L9.86706 32.2316C9.88226 31.8478 10.2034 31.5381 10.5879 31.5381H11.3814C11.4627 31.5381 11.5421 31.5517 11.6189 31.5783C11.6667 31.565 11.6819 31.554 11.6823 31.5536C11.7705 31.3971 11.7705 30.745 11.7705 30.4319C11.7705 29.8003 11.6124 29.0377 11.3354 28.329C11.1917 28.2473 11.0755 28.1238 11.004 27.9744C10.5229 26.967 9.86858 26.3165 9.33734 26.3165C8.79394 26.3165 8.1069 27.0202 7.62772 28.066C7.54944 28.2366 7.41226 28.3753 7.24354 28.4585C6.99312 29.1365 6.85556 29.8345 6.85556 30.4315C6.85556 30.6945 6.85556 31.3921 6.95588 31.5563C6.95702 31.5563 6.97944 31.57 7.04252 31.5856C7.1246 31.554 7.21276 31.5377 7.30092 31.5377H8.09588C8.46638 31.5377 8.77608 31.8196 8.81332 32.1863L8.81712 32.2308C8.81712 32.6568 8.49336 32.9813 8.09588 32.9813H7.30092C7.14322 32.9813 6.99084 32.9285 6.86544 32.8327C6.41134 32.7472 6.09138 32.547 5.88884 32.2209C5.64336 31.8269 5.59852 31.3093 5.59852 30.4315C5.59852 29.6616 5.77636 28.7747 6.09936 27.9277C6.05186 27.7464 6.06782 27.5572 6.14686 27.3866C6.48316 26.6509 6.91104 26.0208 7.38376 25.5652C7.64368 25.3148 7.92298 25.1134 8.2152 24.9663C8.32464 24.7102 8.51464 24.5001 8.74682 24.3675C8.75898 23.3548 8.91478 22.4804 9.20282 21.7595C5.90518 23.4323 3.64532 26.8534 3.64532 30.8043C3.64532 35.853 7.33398 36.1 12.1626 36.1C12.6897 36.1 13.2293 36.0969 13.7807 36.0969H24.2181C24.7688 36.0969 25.3084 36.1 25.8354 36.1C30.6648 36.1 34.355 35.853 34.355 30.8043C34.3546 26.8116 32.0465 23.3605 28.6926 21.7078Z"
      fill="url(#paint0_linear_4437_279)"
    />
    <path
      d="M19.003 22.0369C23.6709 22.0369 27.4546 15.0179 27.4546 10.3503C27.4546 5.68356 23.6709 1.8999 19.003 1.8999C14.3358 1.8999 10.5522 5.68356 10.5522 10.3503C10.5522 15.0179 14.3358 22.0369 19.003 22.0369Z"
      fill="url(#paint1_linear_4437_279)"
    />
    <path
      d="M28.698 27.9863C29.3276 27.9863 29.838 27.4759 29.838 26.8463C29.838 26.2167 29.3276 25.7063 28.698 25.7063C28.0684 25.7063 27.558 26.2167 27.558 26.8463C27.558 27.4759 28.0684 27.9863 28.698 27.9863Z"
      fill="url(#paint2_linear_4437_279)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4437_279"
        x1={34.355}
        y1={36.1}
        x2={22.0261}
        y2={11.4985}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#223E76" />
        <stop offset={0.511069} stopColor="#365699" />
        <stop offset={1} stopColor="#2BA9B4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4437_279"
        x1={27.4546}
        y1={22.0369}
        x2={7.62244}
        y2={5.39031}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#223E76" />
        <stop offset={0.511069} stopColor="#365699" />
        <stop offset={1} stopColor="#2BA9B4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4437_279"
        x1={29.838}
        y1={27.9863}
        x2={27.558}
        y2={25.7063}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#223E76" />
        <stop offset={0.511069} stopColor="#365699" />
        <stop offset={1} stopColor="#2BA9B4" />
      </linearGradient>
    </defs>
  </svg>
);
export default SVGComponent;
